import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfermaDialogComponent } from './conferma-dialog.component';


@NgModule({
    declarations: [
        ConfermaDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        
    ],
    entryComponents: [
        ConfermaDialogComponent
    ],
    exports: [ConfermaDialogComponent]
})
export class ConfermaDialogModule {
}
